<div class="grid lg:grid-cols-12 py-16 bg-gray-50 mb-10">
  <div class="col-span-12 lg:col-span-4 lg:col-start-3">
    <amplify-authenticator [loginMechanisms]="loginMechanisms"
                           [socialProviders]="socialProviders"
                           [signUpAttributes]="signUpAttributes"
                           [hideSignUp]="true"
                           [initialState]="'signIn'">

      <!-- Custom SIGN IN header + footer (keeps Amplify's form submission logic) -->
      <ng-template amplifySlot="sign-in-header"
                   let-toSignUp="toSignUp"
                   let-toForgotPassword="toForgotPassword">
        <div class="bg-gray-50  p-6 rounded-t-lg shadow space-y-4" *ngIf="!needsConfirmation && !needsNewPassword">
          <div>
            <h1 class="self-stretch justify-start text-gray-900 text-2xl font-bold font-['Inter'] leading-loose">Bem-vindo!</h1>
            <p class="self-stretch justify-start text-gray-500 text-sm font-medium font-['Inter']">Ainda não tem uma conta?
              <a routerLink="/planos"
                 class="text-primary-600 text-sm text-blue-700 font-medium font-['Inter'] hover:underline">Criar uma</a>
            </p>
          </div>

          <!-- Custom Sign-In form (Email, Password, and Button) -->
          <!-- These elements are now in your HTML so you can apply any Tailwind classes you want. -->
          <form (submit)="customSignIn($event)" class="space-y-4">
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label for="username"
                       class="self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight">E-mail</label>
                <input id="username"
                       name="username"
                       type="email"
                       required
                       class="w-full border px-4 py-3  rounded-md outline-gray-300 focus:outline-0 text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-50 mt-2"
                       placeholder="seu@email.com"/>
              </div>
              <div>
                <label for="password"
                       class="self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight">Senha</label>
                <input id="password"
                       name="password"
                       type="password"
                       required
                       class="w-full border px-4 py-3  rounded-md outline-gray-300 focus:outline-0 text-gray-500 text-sm font-normal font-['Inter'] focus:ring-blue-500 focus:border-blue-50 mt-2"/>
              </div>
            </div>


            <div *ngIf="signInError" class="text-red-600 text-sm">{{ signInError }}</div>

            <!-- Forgot password moved before the Entrar button -->
            <div class="flex justify-end">
              <button type="button"
                      class="text-right text-sm text-blue-700 hover:underline text-primary-700 font-medium font-['Inter']"
                      (click)="toForgotPassword()">Esqueceu a senha?</button>
            </div>

            <button type="submit"
                    class="bg-blue-600 self-stretch px-5 py-2.5 bg-primary-700 rounded-md inline-flex justify-center items-center gap-2 overflow-hidden w-full disabled:opacity-50 text-white text-sm font-medium font-['Inter']"
                    [disabled]="isSigningIn">
              {{ isSigningIn ? 'Entrando...' : 'Entrar' }}
            </button>

          </form>
        </div>

        <!-- New Password Required flow -->
        <div class="bg-gray-50 p-6 rounded-t-lg shadow space-y-4" *ngIf="needsNewPassword">
          <div>
            <h2 class="text-2xl font-bold text-gray-900 leading-loose">Definir nova senha</h2>
            <p class="text-sm text-gray-500">Você está usando uma senha temporária. Defina uma nova senha para continuar.</p>
          </div>

          <form (submit)="onNewPasswordSubmit($event)" class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label for="np-password" class="block text-sm font-medium text-gray-900">Nova senha</label>
                <input id="np-password" name="new_password" type="password" required
                       class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2" />
              </div>
              <div>
                <label for="np-confirm" class="block text-sm font-medium text-gray-900">Confirmar nova senha</label>
                <input id="np-confirm" name="confirm_new_password" type="password" required
                       class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2" />
              </div>
            </div>

            <div *ngIf="newPasswordError" class="text-red-600 text-sm">{{ newPasswordError }}</div>
            <div *ngIf="newPasswordSuccess" class="text-green-700 text-sm">{{ newPasswordSuccess }}</div>

            <div class="flex items-center justify-between">
              <button type="button" class="text-sm text-blue-700 hover:underline" (click)="backToSignIn()">Voltar</button>
              <button type="submit" class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50"
                      [disabled]="isSettingNewPassword">
                {{ isSettingNewPassword ? 'Atualizando...' : 'Atualizar senha' }}
              </button>
            </div>
          </form>
        </div>

        <!-- Confirm sign-up inline flow when user is unconfirmed -->
        <div class="bg-gray-50 p-6 rounded-t-lg shadow space-y-4" *ngIf="needsConfirmation">
          <div>
            <h2 class="text-2xl font-bold text-gray-900 leading-loose">Confirmar cadastro</h2>
            <p class="text-sm text-gray-500">Enviamos um código para {{ emailForConfirm }}. Digite-o abaixo para confirmar sua conta.</p>
          </div>

          <form (submit)="onConfirmSignUpSubmit($event)" class="space-y-4">
            <div>
              <label for="confirm-signup-code" class="block text-sm font-medium text-gray-900">Código de confirmação</label>
              <input id="confirm-signup-code" name="confirmation_code" type="text" required
                     class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2"
                     placeholder="Código" />
            </div>

            <div *ngIf="confirmError" class="text-red-600 text-sm">{{ confirmError }}</div>
            <div *ngIf="confirmSuccess" class="text-green-700 text-sm">{{ confirmSuccess }}</div>

            <div class="flex items-center justify-between">
              <div class="flex gap-3">
                <button type="button" class="text-sm text-blue-700 hover:underline" (click)="resendConfirmationCode()" [disabled]="isResending">
                  {{ isResending ? 'Reenviando...' : 'Reenviar código' }}
                </button>
                <button type="button" class="text-sm text-blue-700 hover:underline" (click)="backToSignIn()">Voltar ao login</button>
              </div>
              <button type="submit" class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50" [disabled]="isConfirming">
                {{ isConfirming ? 'Confirmando...' : 'Confirmar' }}
              </button>
            </div>
          </form>
        </div>
      </ng-template>


      <!-- Authenticated view -->
      <ng-template amplifySlot="authenticated" let-signOut="signOut">
        <div class="bg-gray-50 p-6 rounded-t-lg shadow space-y-5">
          <div class="space-y-2">
            <h2 class="text-gray-900 text-2xl font-bold font-['Inter'] leading-loose">Você já entrou.</h2>
            <p class="text-gray-500 text-sm font-medium font-['Inter']">
              Sua conta já está autenticada. Você pode ir direto para o painel ou sair e trocar de conta.
            </p>
          </div>

          <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <button
              class="bg-blue-600 text-white px-5 py-2.5 rounded-md inline-flex justify-center items-center gap-2 overflow-hidden w-full text-sm font-medium font-['Inter']"
              (click)="navigateToDashboard()">
              Ir para o painel
            </button>
            <button
              class="bg-white border border-gray-300 px-5 py-2.5 rounded-md outline outline-1 outline-gray-200 inline-flex justify-center items-center w-full text-gray-900 text-sm font-medium font-['Inter'] hover:border-blue-500 hover:bg-blue-50"
              (click)="signOut()">
              Sair
            </button>
          </div>
        </div>
      </ng-template>

      <!-- Custom FORGOT PASSWORD form (visible in HTML for styling) -->
      <ng-template amplifySlot="forgot-password-header" let-context>
        <div class="bg-gray-50 p-6 rounded-t-lg shadow space-y-4 border-0">
          <div>
            <p class="w-96 justify-start text-gray-900 text-2xl font-bold font-['Inter'] leading-loose">Redefinir sua senha</p>
            <p class="self-stretch justify-start text-gray-500 text-base font-normal font-['Inter'] leading-normal">Enviaremos um código por e-mail para que você possa redefinir sua senha</p>
          </div>

          <form (submit)="onForgotSubmit($event, context)">
            <div>
              <label for="fp-username" class="block text-sm font-medium text-gray-900">Email</label>
              <input id="fp-username" name="username" type="email" required
                     class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2"
                     placeholder="Digite seu email" />
            </div>

            <div *ngIf="context.error" class="text-red-600 text-sm">{{ context.error }}</div>

            <div class="flex items-center justify-between mt-3">
              <button type="submit"
                      class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50 w-full"
                      [disabled]="context.isPending">{{ context.isPending ? 'Enviando...' : 'Enviar código' }}</button>
            </div>

            <div class="flex items-center justify-between mt-3">
            <button type="button"
                    class="text-sm text-blue-700 hover:underline"
                    (click)="context.toSignIn()">Voltar ao login</button>
            </div>

            <div class="mt-4 self-stretch text-center justify-start"><span class="text-gray-500 text-sm font-normal font-['Inter'] leading-tight">Ainda precisar de ajuda? Entre em contato com a</span><span class="text-primary-700 text-sm font-medium font-['Inter'] leading-tight text-blue-700"> Casato Brasil.</span></div>

          </form>
        </div>
      </ng-template>

      <!-- Custom CONFIRM RESET PASSWORD form (visible in HTML for styling) -->
      <ng-template amplifySlot="confirm-reset-password-header" let-context>
        <div class="bg-gray-50 p-6 rounded-t-lg shadow">
          <div>
            <p class="w-96 justify-start text-gray-900 text-2xl font-bold font-['Inter'] leading-loose">Criar nova senha</p>
            <p class="self-stretch justify-start text-gray-500 text-base font-normal font-['Inter'] leading-normal">Informe o código recebido e a nova senha.</p>
          </div>

          <form (submit)="onConfirmResetSubmit($event, context)">
            <div class="grid grid-cols-1 gap-4 mt-3">
              <div class="col-span-1">
                <label for="crp-code" class="self-stretch justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight">Digite o código</label>
                <input id="crp-code" name="confirmation_code" type="text" required
                       class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2"
                       placeholder="Digite o código" />
              </div>

              <div class="flex justify-end">
                <button type="button"
                        class="text-sm text-blue-700 hover:underline"
                        (click)="context.resendCode()">Reenviar código</button>
              </div>

              <div class="col-span-1">
                <label for="crp-password" class="block text-sm font-medium text-gray-900">Nova senha</label>
                <input id="crp-password" name="password" type="password" required
                       class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2" />
              </div>
              <div class="md:col-span-1">
                <label for="crp-confirm" class="block text-sm font-medium text-gray-900">Confirmar nova senha</label>
                <input id="crp-confirm" name="confirm_password" type="password" required
                       class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2" />
              </div>
            </div>

            <div *ngIf="context.error" class="text-red-600 text-sm">{{ context.error }}</div>

            <div class="mt-3">
              <button type="submit"
                      class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50 w-full"
                      [disabled]="context.isPending">{{ context.isPending ? 'Confirmando...' : 'Confirmar' }}</button>
            </div>
            <div class="mt-3 text-center justify-start"><span class="text-gray-500 text-sm font-normal font-['Inter'] leading-tight">Ainda precisar de ajuda? Entre em contato com a</span><span class="text-primary-700 text-sm font-medium font-['Inter'] leading-tight text-blue-700"> Casato Brasil.</span></div>
            <div class="mt-3">
                <button type="button"
                        class="text-sm text-blue-700 hover:underline"
                        (click)="context.toSignIn()">Voltar ao login</button>
              </div>
          </form>
        </div>
      </ng-template>

      <!-- Custom CONFIRM SIGN-IN (verification code/MFA) form -->
      <ng-template amplifySlot="confirm-sign-in-header" let-context>
        <div class="bg-gray-50 p-6 rounded-t-lg shadow space-y-4">
          <div>
            <h2 class="text-2xl font-bold text-gray-900 leading-loose">Verificação necessária</h2>
            <p class="text-sm text-gray-500">Digite o código de verificação enviado para o seu dispositivo.</p>
          </div>

          <form (submit)="onConfirmSignInSubmit($event, context)" class="space-y-4">
            <div>
              <label for="mfa-code" class="block text-sm font-medium text-gray-900">Código de verificação</label>
              <input id="mfa-code" name="confirmation_code" type="text" required
                     class="w-full border px-4 py-3 rounded-md outline-gray-300 focus:outline-0 text-gray-700 text-sm focus:ring-blue-500 focus:border-blue-50 mt-2"
                     placeholder="Código" />
            </div>

            <div *ngIf="context.error" class="text-red-600 text-sm">{{ context.error }}</div>

            <div class="flex items-center justify-between">
              <div class="flex gap-3">
                <button type="button" class="text-sm text-blue-700 hover:underline" (click)="context.resendCode()">Reenviar código</button>
                <button type="button" class="text-sm text-blue-700 hover:underline" (click)="context.toSignIn()">Trocar conta</button>
              </div>
              <button type="submit" class="bg-blue-600 text-white px-5 py-2.5 rounded-md disabled:opacity-50" [disabled]="context.isPending">
                {{ context.isPending ? 'Confirmando...' : 'Confirmar código' }}
              </button>
            </div>
          </form>
        </div>
      </ng-template>

      <!-- Override default Amplify sign-in footer with nothing to hide it -->
      <ng-template amplifySlot="sign-in-footer"></ng-template>

    </amplify-authenticator>
  </div>
  <div class="col-span-12 lg:col-span-4">
    <img src="login-image.jpeg"
         alt="Login Image"
         class="hidden lg:block lg:col-span-8 bg-transparent mix-blend-multiply">
  </div>
</div>
